import { locationActions } from "redux/slices/location";
import { getAppDispatch } from "utils/dispatch.util";
import http from "./http.service";
import Promisable from "./promisable.service";
const url = "/driver";
const LocationService = {
  updateDriverLocation: async (data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(locationActions.setDriverLocationFromSocket(data));
    dispatch?.(locationActions.setVehicleLocation(data));
  },
  getDriverLocation: async (data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(locationActions.setLoading(true));
    dispatch?.(locationActions.setEmptyDrivers([]));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/get-last-location`, data)
    );

    if (success) {
      const { drivers } = success.data.data;
      dispatch?.(locationActions.setDriverLocation(drivers || []));
    }

    dispatch?.(locationActions.setLoading(false));
    return [success, error];
  },

  getCarMovement: async (id: any) => {
    const dispatch = getAppDispatch();

    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.get(`/car-movement/${id}`)
    );
    if (success) {
      const { carMovement } = success.data.data;
      dispatch?.(locationActions.setSelectedDriver(carMovement));
    }

    return [success, error];
  },
};
export default LocationService;
